import { render, staticRenderFns } from "./Instructor.vue?vue&type=template&id=41c64201&scoped=true"
import script from "./Instructor.vue?vue&type=script&lang=js"
export * from "./Instructor.vue?vue&type=script&lang=js"
import style0 from "./Instructor.vue?vue&type=style&index=0&id=41c64201&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c64201",
  null
  
)

export default component.exports